/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_ButtonInputs */

const en_selected_button = /** @type {(inputs: Selected_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const de_selected_button = /** @type {(inputs: Selected_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Selected_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selected_button = /** @type {((inputs?: Selected_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_selected_button(inputs)
	return en_selected_button(inputs)
});